<template>
  <div class="sliber">
    <div>
      <p class="sliber-title">体验中心</p>
      <ul class="sliber-ul">
        <li
          :class="currentType == 'wbzx' ? 'active-box' : ''"
          @click="changeTile('wbzx', '/experience/dialogue')"
        >
          <svg
            t="1744077217826"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2782"
            width="18"
            height="18"
            style="float: left; margin-top: 10px"
          >
            <path
              d="M213.333333 213.333333v597.333334h597.333334V213.333333H213.333333zM170.666667 128h682.666666a42.666667 42.666667 0 0 1 42.666667 42.666667v682.666666a42.666667 42.666667 0 0 1-42.666667 42.666667H170.666667a42.666667 42.666667 0 0 1-42.666667-42.666667V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667z m384 298.666667v298.666666h-85.333334v-298.666666H298.666667V341.333333h426.666666v85.333334h-170.666666z"
              :fill="currentType == 'wbzx' ? 'rgb(124 58 238)' : '#5E5C5C'"
              p-id="2783"
            ></path>
          </svg>
          <span class="right" :class="currentType == 'wbzx' ? 'active' : ''"
            >文本对话</span
          >
        </li>
        <!-- <li
          :class="currentType == 'wbqr' ? 'active-box' : ''"
          @click="changeTile('wbqr', '/api-reference/embedding')"
        >
          <span class="left" :class="currentType == 'wbqr' ? 'active' : ''"
            >POST</span
          >
          <span class="right" :class="currentType == 'wbqr' ? 'active' : ''"
            >创建嵌入请求</span
          >
        </li>
        <li
          :class="currentType == 'wbpx' ? 'active-box' : ''"
          @click="changeTile('wbpx', '/api-reference/sort')"
        >
          <span class="left" :class="currentType == 'wbpx' ? 'active' : ''"
            >POST</span
          >
          <span class="right" :class="currentType == 'wbpx' ? 'active' : ''"
            >创建重排序请求</span
          >
        </li> -->
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      currentType: "wbzx",
    };
  },
  watch: {
    "$route.query.type"(newVal) {
      this.currentType = newVal || "wbdh";
    },
  },
  mounted() {
    this.currentType = window.location.href.split("type=")[1];
  },
  methods: {
    changeTile(name, url) {
      this.currentType = name;
      this.$router.push({ path: url, query: { type: name } });
    },
  },
};
</script>
<style scoped>
.sliber {
  font-size: 0.85rem;
  font-weight: bold;
  text-align: left;
  width: 183px;
  /* position: fixed; */
  height: calc(100vh - 96px);
  border-right: 1px solid #f2f2f2;
  margin-right:5px;
  padding-right:10px;
}
.sliber-ul {
  cursor: pointer;
}
.sliber-title {
  margin-bottom: 10px;
}
.sliber .left {
  color: rgb(29 78 217);
  padding: 0 5px;
  background: rgba(96, 165, 250, 0.2);
  /* display: inline-block; */
  border-radius: 6px;
  height: 16px;
  line-height: 16px;
  font-size: 0.6rem;
  float: left;
  margin-top: 10px;
  margin-right: 10px;
}
.sliber .left.active {
  background-color: rgb(49 101 229);
  color: #fff;
}

.sliber li {
  width:154px;
  border-radius: 10px;
  height: 36px;
  line-height: 36px;
  padding-left: 10px;
}
.sliber .active-box {
  color: #fff;
  /* padding:0 5px ; */
  background: rgb(126 59 239 / 10%);
  display: inline-block;
  line-height: 38px;
  font-size: 0.6rem;
}
.sliber .right {
  font-size: 0.85rem;
}
.sliber .right.active {
  color: rgb(124 58 238);
}
</style>